/* eslint-disable import/order */
import Table from '@material-ui/core/Table'
import IconButton from '@material-ui/core/IconButton'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import ZoomInIcon from '@material-ui/icons/ZoomIn'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import queryString from 'query-string'

import consts from '../../../util/consts'
import Paginate from '../../components/Pagination'
import { exportFormatedMoney, useQueryParams } from '../../../util/utils'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'

function List({ classes }) {
  const history = useHistory()
  const location = useLocation()
  const query = useQueryParams(location.search)

  const items = useSelector(state => state.team_produtivity_relatory.items)
  const totalSize = useSelector(
    state => state.team_produtivity_relatory.totalSize
  )
  const page = useSelector(state => state.team_produtivity_relatory.page)

  const rowsPerPage = Number(query.rows) || consts.DEFAULT_PAGINATION

  const pushQuery = changes => {
    history.push(
      `${location.pathname}?${queryString.stringify({ ...query, ...changes })}`
    )
  }

  const onMovePage = (event, newPage) => {
    pushQuery({ page: newPage + 1 })
  }

  const handleChangeRowsPerPage = event => {
    pushQuery({ rows: event.target.value, page: 1 })
  }

  return (
    <>
      <TableContainer
        className={classNames({
          [classes.tableContainer]: true,
          [classes.tableStickHeader]: true,
        })}
      >
        <Table stickyHeader size="medium" className={classes.tableStyle}>
          <TableHead>
            <TableRow>
              <StyledTableCellHeader>ID</StyledTableCellHeader>
              <StyledTableCellHeader>Equipe</StyledTableCellHeader>
              <StyledTableCellHeader>Quantidade</StyledTableCellHeader>
              <StyledTableCellHeader>Valor</StyledTableCellHeader>
              <StyledTableCellHeader>Valor do Técnico</StyledTableCellHeader>
              <StyledTableCellHeader>Ações</StyledTableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <TableRow key={item.id}>
                <StyledTableCellBody>{item.id}</StyledTableCellBody>
                <StyledTableCellBody>{item.team}</StyledTableCellBody>
                <StyledTableCellBody>{item.qty}</StyledTableCellBody>
                <StyledTableCellBody>
                  {exportFormatedMoney(item.value)}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {exportFormatedMoney(item.commission ?? 0)}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  <IconButton
                    component={Link}
                    to={`/relatory-team-produtivity/${item.id}${location.search}`}
                  >
                    <ZoomInIcon fontSize="small" />
                  </IconButton>
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Paginate
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        rows={totalSize}
        page={page - 1}
        handleChangePage={onMovePage}
      />
    </>
  )
}

export default List
